
export function isOnHold(q): boolean {
  return q.start !== null && ["Hold"].includes(q.status);
}

